module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-800.cbd9b56f.ttf";